/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { choosableColumns, defaultColumns } from "../../../Retrofit/store/data/retrofitData";
import { selectEventsData, updateConfiguration } from "../../../Common/store/slices/common";
import {
  clearBundlesToCompare,
  closeSnackbar,
  selectBundlesToCompare,
  selectConfigAxes,
  selectCountOfBundles,
  selectCurrentAxisFilters,
  selectCurrentAxisId,
  selectCurrentFiltersStepperStep,
  selectEditingAxis,
  selectFetchedBundles,
  selectOrderBy,
  selectPaging,
  selectRetrofitConfiguration,
  selectRowsToShow,
  selectSelectedBundle,
  selectSnackbar,
  setAxisFilters,
  setBundle,
  setCurrentFiltersStepperStep,
  setFiltersWrapperOpened,
  setOrderBy,
  setPaging,
  setShowAxisPopup
} from "../../../Retrofit/store/slices/retrofit";
import { getAccessories, logEvent } from "../../../Common/utils/api/api";
import t from "../../../Common/utils/translation/translator";
import useCheckMobileScreen from "../../../Common/utils/useCheckMobileScreen";
import { initDriveAccessories, initMotorAccessories } from "../../../Retrofit/utils/func.util";
import Spinner from "../../../Common/components/Icons/Spinner/Spinner";
import Snackbar from "../../../Common/components/Snackbar/Snackbar";
import TopHeader from "../../../Common/components/TopHeader/TopHeader";
import { useGetRetrofitBundles } from "../useGetRetrofitBundles";
import BundleComparator from "./BundleComparator/BundleComparator";
import ComparisonBar from "./ComparisonBar";
import CorrespondingCrossComponent from "./CorrespondingCrossComponent/CorrespondingCrossComponent";
import DevicesHeader from "./DevicesHeader";
import FiltersWrapper from "./FiltersWrapper";

const AxisPopup = ({ ...props }) => {
  const dispatch = useDispatch();
  const currentAxisId = useSelector(selectCurrentAxisId);
  const configAxes = useSelector(selectConfigAxes);
  const currentAxis = configAxes.find((axis) => axis.id === currentAxisId);
  const currentFiltersStep = useSelector(selectCurrentFiltersStepperStep);
  const bundlesToCompare = useSelector(selectBundlesToCompare);
  const currentFilters = useSelector(selectCurrentAxisFilters);
  const isMobile = useCheckMobileScreen();
  const [isFetchingAccessories, setIsFetchingAccessories] = useState(false);

  const [initialFilters] = useState(useSelector(selectCurrentAxisFilters));

  // close the popup, apply the initial filters bcz the user didn't select a bundle
  const handleClosePopup = () => {
    if (isMobile && currentFiltersStep === 2) {
      dispatch(setCurrentFiltersStepperStep(1));
      return;
    }
    // console.log("reset filters bcz the user didn't select a bundle");
    if (initialFilters !== undefined) {
      dispatch(setAxisFilters({ axisId: currentAxisId, filters: initialFilters }));
    }
    dispatch(setShowAxisPopup(false));
  };

  useEffect(() => {
    dispatch(setFiltersWrapperOpened(null));
  }, []);

  const snackbar = useSelector(selectSnackbar);

  const editingAxis = useSelector(selectEditingAxis);

  const fetchDriveAccessories = async (params = {}) => {
    setIsFetchingAccessories(true);
    // Fetching All Drive Accessories
    const fetchedAccessoriesData = await getAccessories({
      relatedDevice: "Drive Accessories",
      driveRef: params.driveRef, // Access driveRef from paramsv
      motorRef: params.motorRef, // Access motorRef from params
      gearboxRef: params.gearboxRef // Access gearboxRef from params
    }).finally(() => {
      setIsFetchingAccessories(false);
    });

    // Initializing drive accessories to store
    const initializedDriveAccessories = initDriveAccessories(
      fetchedAccessoriesData.Accessories,
      currentFilters.driveFilter.driveInterface[0]
    );
    return initializedDriveAccessories;
  };

  const fetchMotorAccessories = async (params = {}) => {
    setIsFetchingAccessories(true);
    // Fetching All Motor Accessories
    const fetchedAccessoriesData = await getAccessories({
      relatedDevice: "Motor Accessories",
      driveRef: params.driveRef, // Access driveRef from paramsv
      motorRef: params.motorRef, // Access motorRef from params
      gearboxRef: params.gearboxRef // Access gearboxRef from params
    }).finally(() => {
      setIsFetchingAccessories(false);
    });

    // Initializing drive accessories to store
    const initializedMotorAccessories = initMotorAccessories(fetchedAccessoriesData.Accessories);

    return initializedMotorAccessories;
  };

  // const selectedBundle = useSelector(selectSelectedBundle);
  // props of CorrespondingCrossComponent
  // const filters = useSelector(selectCurrentAxisFilters);
  const selectedBundle = useSelector(selectSelectedBundle);
  const eventsData = useSelector(selectEventsData);
  const configuration = useSelector(selectRetrofitConfiguration);

  const selectBundle = async (bundle) => {
    // console.log(bundle);
    if (selectedBundle) {
      console.log("changing current bundle");
      // changing the current bundle
      logEvent(eventsData.locale, eventsData.types.changeBundle, eventsData.tags.none, configuration?.configId);
    } else {
      console.log("else changing current bundle");
      logEvent(
        eventsData.locale,
        eventsData.types.selectBundle,
        eventsData.tags.fromComparator,
        configuration?.configId
      );
    }

    // Call fetchDriveAccessories with params to fetch accessories
    const driveAccessories = await fetchDriveAccessories({
      driveRef: bundle.drive?.commercialReference, // Pass specific driveRef value
      motorRef: bundle.motor?.commercialReference, // Pass specific motorRef value
      gearboxRef: bundle.gearbox?.commercialReference // Pass specific gearboxRef value
    });

    // Call fetchMotorAccessories with params to fetch accessories
    const motorAccessories = await fetchMotorAccessories({
      driveRef: bundle.drive?.commercialReference, // Pass specific driveRef value
      motorRef: bundle.motor?.commercialReference, // Pass specific motorRef value
      gearboxRef: bundle.gearbox?.commercialReference // Pass specific gearboxRef value
    });

    // console.log("select bundle action", bundle);
    dispatch(
      setBundle({
        ...bundle,
        drive: { ...bundle.drive, accessories: driveAccessories },
        motor: { ...bundle.motor, accessories: motorAccessories }
      })
    );

    dispatch(setShowAxisPopup(false));
    // clear the compare list
    dispatch(clearBundlesToCompare());
    dispatch(updateConfiguration());
  };

  // Get fetched (and filtered) bundles from redux
  const fetchedBundles = useSelector(selectFetchedBundles);
  const countOfBundles = useSelector(selectCountOfBundles);

  const rowsToShow = useSelector(selectRowsToShow);
  const paging = useSelector(selectPaging);
  const orderBy = useSelector(selectOrderBy);

  const { refetch: fetchRetrofitBundles, isFetching: isFetchingBundles } = useGetRetrofitBundles(currentFilters);

  const handleApplyFilters = (axisId, newFilters) => {
    dispatch(setAxisFilters({ axisId, filters: newFilters }));
  };

  return (
    <div className="AxisPopup absolute left-0 bg-white w-full z-50 h-full overflow-auto top-0" {...props}>
      <TopHeader data-testid="top-header" />
      {/* <FiltersStepper /> */}
      <div
        className={`md:p-8 md:pt-0 bg-white md:bg-gray-200 min-h-full
      ${editingAxis ? "blur-sm" : ""}`}
      >
        <div className={`flex-1 flex justify-end items-center space-x-2 right-1 ${isMobile ? "bg-white" : ""}`}>
          <div
            id="retrofit-select-button-cancel"
            className="flex items-center w-max h-max cursor-pointer text-lg text-gray-500 rounded-sm border-solid p-[0.25rem] hover:text-gray-600 transition-all duration-75"
            onClick={handleClosePopup}
          >
            <span className="hidden md:inline md:visible text-sm">{t("msizer.ui.popup.button.cancel")}</span>
            <AiOutlineClose />
          </div>
        </div>
        <div
          className={isMobile ? "fixed w-full z-50 top-3" : "fixed z-fullScreen md:inset-x-8 inset-y-0 h-fit top-16"}
        >
          <Snackbar
            id={snackbar.id}
            opened={snackbar.show}
            onClose={() => dispatch(closeSnackbar(snackbar.id))}
            hideCTA={snackbar.hideCTA}
            customMessage={snackbar.customMessage}
          />
        </div>
        <div className="p-2 space-y-4 bg-white rounded-sm">
          <span
            title={currentAxis.name}
            className="md:hidden text-gray-500 font-bold whitespace-nowrap overflow-hidden text-ellipsis w-full"
          >
            {currentAxis.name}
          </span>
          <DevicesHeader axis={currentAxis} />
          {currentFiltersStep === 1 && (
            <>
              <div
                className={`bg-gray-50 rounded backdrop-blur-xs bg-opacity-50 w-full h-full top-0 left-0 fixed z-20 flex items-center justify-center ${
                  !isFetchingAccessories && "hidden"
                }`}
              >
                <Spinner big />
              </div>
              <div>
                {!editingAxis && (
                  <FiltersWrapper
                    filters={currentFilters}
                    onApplyFilters={handleApplyFilters}
                    axisId={currentAxisId}
                    refetchBundles={fetchRetrofitBundles}
                  />
                )}
                {!editingAxis && (
                  <CorrespondingCrossComponent
                    filters={currentFilters}
                    selectedBundle={selectedBundle}
                    onSelectBundle={selectBundle}
                    defaultColumns={defaultColumns}
                    choosableColumns={choosableColumns}
                    bundles={fetchedBundles}
                    fetchBundles={fetchRetrofitBundles}
                    isFetchingBundles={isFetchingBundles}
                    paging={paging}
                    setPaging={(p) => dispatch(setPaging(p))}
                    rowsToShow={rowsToShow}
                    orderBy={orderBy}
                    setOrderBy={(order) => dispatch(setOrderBy(order))}
                    countOfBundles={countOfBundles}
                  />
                )}
              </div>
            </>
          )}

          {currentFiltersStep === 2 && (
            <>
              <BundleComparator onSelectBundle={selectBundle} />
            </>
          )}
        </div>
      </div>
      {bundlesToCompare?.length > 0 && currentFiltersStep === 1 && <ComparisonBar />}
    </div>
  );
};

export default AxisPopup;
